(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["pesk-imported-reviews"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pesk-ali-reviews')) {
    customElements.define('pesk-ali-reviews', class extends HTMLElement {
      async connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.grid = this.querySelector('[data-review-grid]');
        this.more = this.querySelector('[data-review-more]');
        this.empty = this.querySelector('[data-review-empty]');
        this.position = this.querySelector('[data-review-position]');
        this.pause = this.querySelector('[data-review-pause]');
        this.abortController = new AbortController();
        this.events = new AbortController();
        this.reducedMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
        this.paused = this.reducedMotion;
        this.hovered = false;
        this.autoEnabled = this.dataset.autoplay === 'true';
        try {
          const response = await fetch(this.dataset.reviewsUrl, { signal: this.abortController.signal });
          if (!response.ok) return;
          const data = await response.json();
          if (data.schemaVersion !== 2) return;
          this.catalog = new Map();
          const catalog = this.querySelector('[data-review-catalog]');
          if (catalog) catalog.content.querySelectorAll('[data-review-product-id]').forEach(link => this.catalog.set(link.dataset.reviewProductId,link));
          const ids = this.dataset.reviewMode === 'all' ? [...this.catalog.keys()] : [this.dataset.productId];
          const seen = new Set();
          const lists = [];
          for (const id of ids) {
            const entry = data.products?.[id];
            if (!entry || entry.shopifyProductId !== `gid://shopify/Product/${id}`) continue;
            if (!/^\d+$/.test(entry.aliexpressProductId) || entry.sourceUrl !== `https://www.aliexpress.com/item/${entry.aliexpressProductId}.html`) continue;
            const reviews = (Array.isArray(entry.reviews) ? entry.reviews : []).filter(review => {
              const valid = review.source === 'AliExpress' && review.sourceMatched === true && review.aliexpressProductId === entry.aliexpressProductId && [4,5].includes(review.rating) && typeof review.id === 'string' && review.id.trim() && typeof review.text === 'string' && review.text.trim() && typeof review.sourceText === 'string' && review.sourceText.trim() && !seen.has(review.id);
              if (valid) seen.add(review.id);
              return valid;
            }).map(review => ({...review,productId:id}));
            if (reviews.length) lists.push(reviews);
          }
          this.reviews = [];
          for (let index = 0; index < Math.max(0,...lists.map(list => list.length)); index++) {
            for (const list of lists) if (list[index]) this.reviews.push(list[index]);
          }
          const productCount = this.querySelector('[data-review-products-count]');
          if (productCount) productCount.textContent = lists.length;
          if (!this.reviews.length) return;
          this.hidden = false;
          if (this.empty) this.empty.hidden = true;
          const counts = { all: this.reviews.length, 4: this.reviews.filter(r => r.rating === 4).length, 5: this.reviews.filter(r => r.rating === 5).length };
          const average = this.reviews.reduce((sum,r) => sum + r.rating, 0) / counts.all;
          this.querySelector('[data-review-average]').textContent = new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 1, minimumFractionDigits: 1 }).format(average);
          this.querySelector('.psk-ali-reviews__summary-stars').style.setProperty('--rating-percent', `${average * 20}%`);
          this.querySelector('[data-review-count]').textContent = this.dataset.countLabel.replace('__COUNT__', String(counts.all));
          for (const rating of [4,5]) {
            this.querySelector(`[data-review-total="${rating}"]`).textContent = counts[rating];
            this.querySelector(`[data-review-bar="${rating}"]`).style.width = `${counts[rating] / counts.all * 100}%`;
          }
          const on = (el,event,fn) => el.addEventListener(event,fn,{ signal: this.events.signal });
          this.querySelectorAll('[data-review-filter]').forEach(button => {
            const key = button.dataset.reviewFilter;
            button.querySelector('[data-review-filter-count]').textContent = counts[key];
            button.hidden = !counts[key];
            on(button,'click',() => { this.setPaused(true); this.filter(key); });
          });
          on(this.more,'click',() => { this.setPaused(true); const start = this.visibleCount; this.renderNext(); const next = this.grid.children[start]; if (next) this.grid.scrollTo({ left: next.offsetLeft - this.grid.firstElementChild.offsetLeft, behavior: this.reducedMotion ? 'instant' : 'smooth' }); });
          on(this.querySelector('[data-review-prev]'),'click',() => { this.setPaused(true); this.move(-1); });
          on(this.querySelector('[data-review-next]'),'click',() => { this.setPaused(true); this.move(1); });
          on(this.pause,'click',() => this.setPaused(!this.paused));
          on(this,'mouseenter',() => { this.hovered = true; });
          on(this,'mouseleave',() => { this.hovered = false; });
          on(this.grid,'scroll',() => this.updatePosition());
          on(this.grid,'pointerdown',() => this.setPaused(true));
          on(this.grid,'keydown',event => {
            if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.setPaused(true); this.move(event.key === 'ArrowRight' ? 1 : -1); }
          });
          this.resizeObserver = new ResizeObserver(() => this.updatePosition());
          this.resizeObserver.observe(this.grid);
          this.observer = new IntersectionObserver(entries => { this.inView = entries[0].isIntersecting; }, { threshold: .25 });
          this.observer.observe(this.grid);
          this.filter('all');
          this.setPaused(this.paused);
          this.timer = setInterval(() => { if (this.autoEnabled && !this.paused && this.inView && !this.hovered && !document.hidden && !this.matches(':focus-within') && this.grid.scrollWidth > this.grid.clientWidth + 5) this.move(1); }, 6000);
        } catch (error) { if (this.empty && error.name !== 'AbortError') this.empty.hidden = false; }
      }
      disconnectedCallback() { this.abortController?.abort(); this.events?.abort(); clearInterval(this.timer); this.observer?.disconnect(); this.resizeObserver?.disconnect(); this.started = false; }
      element(tag,className,text) { const el = document.createElement(tag); if (className) el.className = className; if (text) el.textContent = text; return el; }
      setPaused(paused) { this.paused = paused; this.pause.textContent = paused ? this.dataset.playLabel : this.dataset.pauseLabel; this.pause.setAttribute('aria-pressed',String(paused)); this.position.setAttribute('aria-live',paused ? 'polite' : 'off'); }
      filter(key) {
        this.querySelectorAll('[data-review-filter]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.reviewFilter === key)));
        this.filtered = key === 'all' ? this.reviews : this.reviews.filter(r => r.rating === Number(key));
        this.grid.replaceChildren(); this.visibleCount = 0; this.renderNext(); this.grid.scrollTo({ left: 0, behavior: 'instant' }); this.updatePosition();
      }
      renderNext() {
        const start = this.visibleCount;
        this.visibleCount = Math.min(this.filtered.length, start + Math.max(3,Math.min(12,Number(this.dataset.pageSize) || 6)));
        const fragment = document.createDocumentFragment();
        for (const review of this.filtered.slice(start,this.visibleCount)) {
          const card = this.element('article','psk-ali-review'); card.dataset.reviewId = review.id; card.dataset.reviewRating = review.rating; card.dataset.reviewProductId = review.productId;
          if (this.dataset.reviewMode === 'all') { const product = this.catalog.get(review.productId)?.cloneNode(true); if (product) { product.className = 'psk-ali-review__product'; card.append(product); } }
          const top = this.element('div','psk-ali-review__top');
          const stars = this.element('span','psk-ali-review__stars','★'.repeat(review.rating) + '☆'.repeat(5-review.rating)); stars.setAttribute('role','img'); stars.setAttribute('aria-label',this.dataset.ratingLabel.replace('__RATING__',String(review.rating)));
          const quote = this.element('span','psk-ali-review__quote','“'); quote.setAttribute('aria-hidden','true'); top.append(stars,quote); card.append(top,this.element('blockquote','',review.text.replace(/aliexpress|shopify/gi,'[…]')));
          if (review.text.length > 220 || review.text.split('\n').length > 6) {
            const button = this.element('button','psk-ali-review__read',this.dataset.readMoreLabel); button.type = 'button'; button.setAttribute('aria-expanded','false');
            button.addEventListener('click',() => { this.setPaused(true); const expanded = card.classList.toggle('is-expanded'); button.setAttribute('aria-expanded',String(expanded)); button.textContent = expanded ? this.dataset.readLessLabel : this.dataset.readMoreLabel; },{ signal: this.events.signal }); card.append(button);
          }
          const images = (Array.isArray(review.images) ? review.images : []).filter(url => { try { return new URL(url).protocol === 'https:'; } catch { return false; } });
          if (images.length) { const photos = this.element('div','psk-ali-review__photos'); for (const url of images) { const image = this.element('img','psk-ali-review__photo'); image.src = url; image.alt = this.dataset.photoLabel; image.width = 600; image.height = 480; image.loading = 'lazy'; image.decoding = 'async'; photos.append(image); } card.append(photos); }
          const identity = this.element('div','psk-ali-review__identity'); const avatar = this.element('span','psk-ali-review__avatar','★'); avatar.setAttribute('aria-hidden','true');
          const person = this.element('div'); person.append(this.element('strong','psk-ali-review__author',(/aliexpress|shopify/i.test(review.author || '') ? this.dataset.authorLabel : review.author) || this.dataset.authorLabel));
          if (typeof review.date === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(review.date)) { const date = new Date(`${review.date}T00:00:00Z`); if (!Number.isNaN(date.getTime())) { const time = this.element('time','psk-ali-review__date',new Intl.DateTimeFormat('fr-FR',{ day:'numeric',month:'long',year:'numeric',timeZone:'UTC' }).format(date)); time.dateTime = review.date; person.append(time); } }
          identity.append(avatar,person); card.append(identity);
          if (typeof review.country === 'string' && /^[A-Z]{2}$/.test(review.country)) { const country = typeof Intl.DisplayNames === 'function' ? new Intl.DisplayNames(['fr-FR'],{type:'region'}).of(review.country) : review.country; const chip = this.element('span','psk-ali-review__country'); const flag = this.element('span','',String.fromCodePoint(...[...review.country].map(c => 127397+c.charCodeAt(0)))); flag.setAttribute('aria-hidden','true'); chip.append(flag,document.createTextNode(country)); card.append(chip); }
          card.append(this.element('span','psk-ali-review__source',this.dataset.sourceLabel)); if (review.translated === true) card.append(this.element('small','psk-ali-review__translation',this.dataset.translationLabel)); fragment.append(card);
        }
        this.grid.append(fragment); this.more.hidden = this.visibleCount >= this.filtered.length; this.updatePosition();
      }
      move(direction) {
        const card = this.grid.querySelector('.psk-ali-review'); if (!card) return;
        const step = card.getBoundingClientRect().width + 16; let max = this.grid.scrollWidth - this.grid.clientWidth;
        if (direction > 0 && this.grid.scrollLeft >= max - 5 && this.visibleCount < this.filtered.length) { this.renderNext(); max = this.grid.scrollWidth - this.grid.clientWidth; }
        const target = direction > 0 && this.grid.scrollLeft >= max - 5 ? 0 : direction < 0 && this.grid.scrollLeft <= 5 ? max : Math.max(0, Math.min(max,this.grid.scrollLeft + direction * step));
        this.grid.scrollTo({left:target,behavior:this.reducedMotion ? 'instant':'smooth'});
      }
      updatePosition() {
        if (!this.filtered?.length) return;
        const card = this.grid.querySelector('.psk-ali-review'); if (!card) return;
        const step = card.getBoundingClientRect().width + 16; const start = Math.round(this.grid.scrollLeft / step) + 1; const end = Math.min(this.filtered.length,start + Math.max(1,Math.floor((this.grid.clientWidth + 16) / step)) - 1);
        this.position.textContent = this.dataset.positionLabel.replace('__START__',String(start)).replace('__END__',String(end)).replace('__TOTAL__',String(this.filtered.length));
        const overflow = this.grid.scrollWidth > this.grid.clientWidth + 5; this.querySelector('[data-review-navigation]').hidden = !overflow; this.pause.hidden = !this.autoEnabled;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["pesk-product-details"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('pesk-product-details')) {
    customElements.define('pesk-product-details', class extends HTMLElement {
      connectedCallback() {
        this.controller?.abort();
        this.controller = new AbortController();
        const signal = this.controller.signal;
        const select = this.closest('.pz-product-info')?.querySelector('[data-psk-variant]');
        let variants;
        try { variants = JSON.parse(this.querySelector('[data-pd-variants]').textContent); } catch { return; }
        const update = () => {
          const variant = variants.find(item => String(item.id) === select?.value);
          if (!variant) return;
          this.querySelector('[data-pd-variant]').textContent = variant.label;
          const content = this.querySelector('[data-pd-content]');
          if (content) content.textContent = variant.content;
          const dimensions = this.querySelector('[data-pd-dimensions-row]');
          if (dimensions) dimensions.hidden = !variant.showDimensions;
          const photo = this.querySelector('[data-pd-photo] img');
          if (photo && variant.image) {
            photo.removeAttribute('srcset');
            photo.removeAttribute('sizes');
            photo.src = variant.image;
            photo.alt = variant.label;
          }
        };
        select?.addEventListener('change', update, { signal });
        update();
        const more = this.querySelector('[data-pd-more]');
        const target = document.getElementById(more.getAttribute('aria-controls'));
        more.addEventListener('click', event => {
          if (!target) return;
          event.preventDefault();
          target.open = true;
          const summary = target.querySelector('summary');
          summary?.focus({ preventScroll: true });
          target.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        }, { signal });
      }
      disconnectedCallback() { this.controller?.abort(); }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
